import { useEffect, useRef, useState } from 'react'
import styles from './PrivacyPageMobile.module.less'
import cls from 'classnames'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import rehypeRaw from 'rehype-raw'
import { Spin } from 'antd'
import { ORDER_ICONS } from '../../PrivacyPage'
import { INTERNAL_HOST } from '@/commonConst'

// 预加载两个 markdown 文件
const loadMarkdownZh = () => import('@/docs/Privacy_policy_Adeff_zh.md')
const loadMarkdownEn = () => import('@/docs/Privacy_policy_Adeff.md')


function PrivacyPageMobile() {
  const [md, setMd] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(true)
  const index = useRef(0)
  const isInternal = INTERNAL_HOST.includes(location.hostname)

  useEffect(() => {
    const loadMarkdown = async () => {
      try {
        const loadFn = isInternal ? loadMarkdownZh : loadMarkdownEn
        const file = await loadFn()
        const res = await fetch(file.default)
        const content = await res.text()
        /** 下载下来的 doc 读出来 ' ' 是编码形式的，影响了页面分隔字符的样式，这里手动替换 */
        setMd(content.replace(/\u00A0/g, ' '))
      } catch (error) {
        console.error('Failed to load markdown:', error)
      } finally {
        setLoading(false)
      }
    }

    loadMarkdown()
  }, [])

  return (
    <div className={cls(styles.privacyPage)} data-testid='privacy-page'>
      <div className={styles.privacyPageContent}>
        {
          isInternal
            ? <p className={styles.title}>《AdEff个人信息保护政策》</p>
            : <p className={styles.title}>Privacy policy-AdEff</p>
        }
        <div className={cls(styles.content, styles.markdownBody)}>
          {loading && (
            <div className={styles.loading}>
              <Spin />
            </div>
          )}
          {!loading && (
            <Markdown
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw]}
              components={{
                h1: ({ children }) => {
                  index.current++
                  return (
                    <h1 className={styles.h1}>
                      <img className={styles.orderIcon} src={ORDER_ICONS[index.current]} />
                      {children}
                    </h1>
                  )
                },
              }}
            >
              {md}
            </Markdown>
          )}
        </div>
      </div>
    </div>
  )
}

export default PrivacyPageMobile
